/* The product gallery on a phone: a swipeable track with a dot per image.
   On desktop the CSS puts the images back into the grid and hides the dots. */
(function () {
  function build(gallery) {
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.mk-gallery__item'));
    if (items.length < 2 || gallery.dataset.mkGallery === 'on') return;
    gallery.dataset.mkGallery = 'on';

    var dots = document.createElement('div');
    dots.className = 'mk-gallery__dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Product images');
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mk-gallery__dot';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + items.length);
      b.addEventListener('click', function () {
        item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dots.appendChild(b);
    });
    gallery.insertAdjacentElement('afterend', dots);

    var buttons = Array.prototype.slice.call(dots.children);
    function mark(i) {
      buttons.forEach(function (b, n) {
        b.classList.toggle('is-on', n === i);
        b.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    }
    mark(0);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) mark(items.indexOf(e.target));
        });
      }, { root: gallery, threshold: 0.6 });
      items.forEach(function (item) { io.observe(item); });
    } else {
      gallery.addEventListener('scroll', function () {
        mark(Math.round(gallery.scrollLeft / (gallery.clientWidth || 1)));
      });
    }
  }

  function start() {
    Array.prototype.slice.call(document.querySelectorAll('.mk-gallery')).forEach(build);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
